import React, { useState } from "react";
import "./ProductDetails.css";

const ProductDetails = ({ product, onBack }) => {
  const [activeImage, setActiveImage] = useState(0);

  // حماية في حال عدم وجود بيانات للمنتج
  if (!product) return null;

  return (
    <div className="product-details-page">
      {/* الهيدر العلوي الثابت */}
      <div className="sticky-header">
        <button
          onClick={onBack}
          className="back-button-new"
          aria-label="الرجوع للخلف"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="back-icon"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
          <span>الرجوع للخلف</span>
        </button>

        <h2 className="header-title">تفاصيل المنتج</h2>
        <div className="header-spacer"></div>
      </div>

      <div className="product-container">
        <div className="product-main-grid">
          {/* قسم معرض الصور */}
          <div className="image-gallery-section">
            <div className="main-image-wrapper">
              <img
                key={activeImage} // هذا السطر ضروري جداً لتفعيل الأنيميشن عند كل تغيير
                src={product.images ? product.images[activeImage] : product.img}
                alt={product.name}
                className="main-image fade-animation" // أضفنا هذا الكلاس
              />
            </div>

            {/* الصور المصغرة - تظهر فقط إذا وجد أكثر من صورة */}
            {product.images && product.images.length > 1 && (
              <div className="thumbnail-list">
                {product.images.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveImage(idx)}
                    className={`thumbnail-btn ${
                      activeImage === idx ? "active" : ""
                    }`}
                  >
                    <img src={img} alt={`${product.name} thumbnail ${idx}`} />
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* قسم معلومات المنتج */}
          <div className="product-info-section">
            <div className="info-header">
              <span className="category-tag"></span>
              <h1 className="product-name-h1">{product.name}</h1>
            </div>

            <div className="details-stack">
              {/* عن المنتج */}
              <section className="info-section-item">
                <h3 className="section-title">
                  <span className="title-indicator"></span>
                  عن المنتج
                </h3>
                <p className="description-text">
                  {product.description || product.desc}
                </p>
              </section>

              {/* بطاقات الخصائص */}
              <div className="specs-grid">
                <div className="spec-card weight">
                  <h4 className="spec-label">الوزن الصافي</h4>
                  <p className="spec-value">{product.weight || "غير محدد"}</p>
                </div>
                <div className="spec-card packaging">
                  <h4 className="spec-label">نوع التعبئة</h4>
                  <p className="spec-value">
                    {product.packaging || "تعبئة مصنعية"}
                  </p>
                </div>
              </div>

              {/* المكونات */}
              {product.ingredients && (
                <section className="info-section-item">
                  <h3 className="section-title">
                    <span className="title-indicator"></span>
                    المكونات
                  </h3>
                  <div className="ingredients-flex">
                    {product.ingredients.map((ing, i) => (
                      <span key={i} className="ingredient-chip">
                        {ing}
                      </span>
                    ))}
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
